import { createThePDF, savePDF } from '@/utils/excel/order';

export function printIFSOrderPDF(order) {
  const dd = createThePDF(order);
  savePDF(dd, order.ORDER_NO);
}
